import type { Auth0ContextInterface } from "@auth0/auth0-react";
import type { MFEDependencies } from "@pepperstone/mfe-dev-kit/types";

export const getDependenciesSimple = (
  auth0: Auth0ContextInterface
): MFEDependencies => {
  return {
    sessionDomainModel: {
      checkIsAuthenticated: async () => {
        return !auth0 || auth0.isAuthenticated;
      },
      getAccessToken: async (params?: { refresh?: boolean }) => {
        if (auth0.isAuthenticated) {
          return await auth0.getAccessTokenSilently(
            params?.refresh ? { cacheMode: "off" } : undefined
          );
        }
        await auth0.loginWithRedirect();
        return "";
      },
      login: async () => {
        await auth0.loginWithRedirect();
      },
      logout: async () => {
        await auth0.logout();
      },
    },
    logger: {
      debug: console.debug,
      error: console.error,
      info: console.info,
      warn: console.warn,
      fatal: console.error,
    },
    analytics: {
      track: async (eventName, properties) => {
        console.log(`Track: ${eventName}`, properties);
      },
    },
    locale: "en",
    authUserDomainModel: {
      getPublicWatchlists: async () => [],
      // biome-ignore lint/suspicious/noExplicitAny: n/a
      getOnboardingStatus: async () => ({}) as any,
      // biome-ignore lint/suspicious/noExplicitAny: n/a
      getTradingAccounts: async () => ({}) as any,
      getAnnouncements: async () => [],
      getAccountMessageIds: async () => [],
      getProApplications: async () => [],
      // biome-ignore lint/suspicious/noExplicitAny: n/a
      getProfile: async () => ({}) as any,
    },
    guestUserDomainModel: {
      getPublicWatchlists: async () => [],
    },
  };
};
